/* dashboard-rediseno (15-oct-2026): EL CASCARON DE TODA TARJETA DE LA LISTA DEL PANEL.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Pinta las tres zonas de alto fijo de `anatomia.js` (encabezado, detalle y pie) y nada mas: lo
   que va en cada una lo decide quien lo monta (la tarjeta de documento del Panel, la parte de un
   documento dividido, la publicacion de un grupo, la tarjeta bloqueada y el padre cerrado).

   Marcas: `tarjeta-<id><sufijo>` en el cascaron, con `data-estado` (el estado que pinta, A1 a
   A18, B3, C3 o E2, para la medicion de Chrome), y `-encabezado`, `-titulo`, `-detalle` y
   `-pie` en sus zonas. `atenuada` (bloqueada o caducada) baja el icono, el titulo y el detalle al
   50 %; el menu de tres puntos queda entero.

   Segunda vuelta (D1 y D9): la tarjeta mide su ancho de texto (`anchoDeTarjeta.js`) y lleva las
   marcas `data-angosta` y `data-estrecha`; es el grupo `tarjeta` de las clases de adentro (el
   grupo y el hueco del pie viven en las constantes de `anatomia.js`). */
import React, { useRef } from 'react';
import { useAnchoDeTexto } from './anchoDeTarjeta';
import {
  TARJETA, TARJETA_INTERNA, ZONA_ENCABEZADO, ZONA_ENCABEZADO_PARTE, ZONA_DETALLE, ZONA_PIE,
  CAJA_ICONO, CAJA_ICONO_INTERNA, TITULO, TITULO_PARTE, ATENUADA_50,
} from './anatomia';

export default function CascaronDeTarjeta({
  id, sufijo = '', estado, interna = false, parte = false, atenuada = false,
  icono, rotuloIcono, testidIcono, tipoIcono, titulo, tituloTitle, menu, detalle, pie, entreTituloYMenu,
  className = '', style, onClick, role, tabIndex, onKeyDown, ariaLabel, ariaBusy, extra,
}) {
  const base = `${interna ? TARJETA_INTERNA : TARJETA} ${className}`.trim();
  const tenue = atenuada ? ` ${ATENUADA_50}` : '';
  const raiz = useRef(null);
  useAnchoDeTexto(raiz);
  return (
    <div ref={raiz} className={base} style={style} onClick={onClick} role={role} tabIndex={tabIndex} onKeyDown={onKeyDown}
      aria-label={ariaLabel} aria-busy={ariaBusy} data-testid={`tarjeta-${id}${sufijo}`} data-estado={estado}>
      <div className={parte ? ZONA_ENCABEZADO_PARTE : ZONA_ENCABEZADO} data-testid={`tarjeta-${id}-encabezado${sufijo}`}>
        <div className={`${interna ? CAJA_ICONO_INTERNA : CAJA_ICONO}${tenue}`} role="img" aria-label={rotuloIcono}
          data-testid={testidIcono} data-tipo={tipoIcono}>
          {icono}
        </div>
        <p className={`${parte ? TITULO_PARTE : TITULO}${tenue}`} title={tituloTitle} data-testid={`tarjeta-${id}-titulo${sufijo}`}>{titulo}</p>
        {entreTituloYMenu}
        {menu}
      </div>
      <div className={ZONA_DETALLE} data-testid={`tarjeta-${id}-detalle${sufijo}`}>
        <div className={`flex flex-col min-w-0${tenue}`}>{detalle}</div>
      </div>
      <div className={ZONA_PIE} data-testid={`tarjeta-${id}-pie${sufijo}`}>
        {pie}
      </div>
      {extra}
    </div>
  );
}
